'use client'

import Link from '@/modules/shared/components/Link'
import Image from 'next/image'
import { Phone, Mail, Menu, User, LogOut } from 'lucide-react'
import { rootPath } from '@/modules/shared/constants/menu'
import { useState } from 'react'
import { useAuth } from '@/modules/auth/contexts/AuthContext'

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { isAuthenticated, user, isLoading } = useAuth()

  const primaryMenu = [
    { href: `${rootPath}/gioi-thieu`, label: 'Giới thiệu' },
    { href: `${rootPath}/giai-phap`, label: 'Giải pháp' },
    { href: `${rootPath}/trang/goi-dich-vu-va-phi`, label: 'Bảng giá' },
    { href: `${rootPath}/bai-viet`, label: 'Bài viết' },
  ]

  const secondaryMenu = [
    { href: `${rootPath}/ban-an`, label: 'Bản án' },
    { href: `${rootPath}/hop-dong-mau`, label: 'Hợp đồng mẫu' },
    { href: `${rootPath}/van-ban-phap-luat`, label: 'Văn bản pháp luật' },
    { href: '/tra-cuu-ma-hs', label: 'Tra cứu mã HS' },
    { href: '#', label: 'Thuật ngữ Pháp lý' },
  ]

  return (
    <header>
      {/* Top Bar */}
      <div className="bg-[#2c3e50] text-white text-[13px] font-[500] py-[10px]"
      >
        <div className="flex justify-between container-fluid  px-[12px]">
          <div className="flex items-center gap-1">
            <Phone className="w-3 h-2.5" fill='currentColor' />
            <span className='mr-4'>0971.654.238</span>
            <Mail className="w-3.5 h-3.5" />
            <span>service.center@caselaw.vn</span>
          </div>
          <div className="pr-px">
            <Link href={`${rootPath}/trang/huong-dan-su-dung`} className="hover:text-gray-300 transition-colors">
              Hướng dẫn sử dụng
            </Link>
            <span className="text-white mx-[18px]">|</span>
            <Link href={`${rootPath}/lien-he`} className="hover:text-gray-300 transition-colors">
              Liên hệ
            </Link>
          </div>
        </div>
      </div >

      {/* Main Navigation */}
      <nav className="border-b border-[#f9f1f1] min-h-[62px]  mt-[6px]" >
        <div className="container-fluid w-full ">
          <div className="flex items-center  mr-[16px]">
            {/* Logo */}
            <div className="flex items-center">
              <Link href={rootPath} className="flex items-center">
                <Image
                  loading='eager'
                  src="https://caselaw.vn/images/icon/logo-header.png"
                  alt="CASELAW Logo"
                  width={50}
                  height={50}
                  className="h-[45px] w-[45px]"
                />
              </Link>
            </div>

            {/* Mobile Menu Toggle */}
            <button
              className="md:hidden ml-auto p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle menu"
            >
              <Menu className="w-6 h-6" />
            </button>

            {/* Desktop Navigation - Primary Menu (left, after logo) */}
            <ul className="hidden md:flex items-center">
              {primaryMenu.map((item) => (
                <li key={item.href} className=" flex items-center">
                  <Link
                    href={item.href}
                    className="text-[14px] text-black font-bold px-[10px]  hover:text-[#00479C] transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>

            {/* Desktop Navigation - Right side (secondary + auth) */}
            <div className="hidden md:flex items-center  ml-auto">
              {/* Secondary Menu Group */}
              <div className="inline-flex items-center bg-[#E3F2FD] rounded-[5px] p-[2px] overflow-hidden">
                {secondaryMenu.map((item, index) => (
                  <Link
                    key={item.href}
                    href={item.href}
                    className={`text-[13px] font-medium p-[8px] whitespace-nowrap transition-[background-color,color] duration-300 inline-block text-[#00479C] hover:bg-[#00479C] hover:text-white
                      ${index < secondaryMenu.length - 1 ? 'border-r border-[rgba(0,71,156,0.2)]' : ''}`}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>

              {/* Auth Buttons / User Info */}
              <div className="flex items-center ml-2.5">
                {isLoading ? (
                  <div className="w-8 h-8 rounded-full bg-gray-200 animate-pulse" />
                ) : isAuthenticated && user ? (
                  <div className="group flex items-center gap-1 rounded-[5px] ">
                    {/* Avatar */}
                    <Link href="https://caselaw.vn/myprofile" className='flex items-center gap-2 p-2 rounded-[5px] hover:bg-[#00479C] transition-colors'>
                      <div className="w-7 h-7 rounded-full bg-[#73c1ef] group-hover:bg-[#5ba8d8] flex items-center justify-center transition-colors">
                        <User className="w-4 h-4 text-[#2c3e50] group-hover:text-white transition-colors" fill="currentColor" />
                      </div>
                      {/* Greeting */}
                      <span className="text-[13px] font-medium text-gray-800 group-hover:text-white transition-colors">
                        Hi, {user.display_name?.split(' ')[0]}!
                      </span>
                    </Link>
                    {/* Thoát button */}
                    <a
                      href="https://caselaw.vn/logout"
                      className="flex items-center gap-1.5 px-4 py-2 text-[13px] font-medium text-white bg-[#e05252] rounded-[5px] hover:bg-[#c94040] transition-colors"
                    >
                      <LogOut className="w-4 h-4" />
                      Thoát
                    </a>
                  </div>
                ) : (
                  <>
                    <Link href="https://caselaw.vn/auth/register" className="px-[20px] py-[8px] text-[14px] font-medium text-[#00479C] bg-white border-2 border-[#00479C] rounded-[5px] hover:bg-[#00479C] hover:text-white transition-colors">
                      Đăng ký
                    </Link>
                    <Link href="https://caselaw.vn/auth/login" className="px-[20px] py-[8px] text-[14px] font-medium text-white bg-[#00479C] border-2 border-[#00479C] rounded-[5px] hover:bg-[#003870] transition-colors ml-2.5">
                      Đăng nhập
                    </Link>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="md:hidden absolute top-[108.5px] left-0 right-0 bg-white border-b border-gray-200 shadow-lg z-50">
              <div className="px-4 py-4 space-y-4">
                {/* Primary Menu Mobile */}
                <div className="space-y-2">
                  {primaryMenu.map((item) => (
                    <Link
                      key={item.href}
                      href={item.href}
                      className="block py-2 text-gray-700 font-bold hover:text-[#00479C]"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>

                {/* Secondary Menu Mobile */}
                <div className="border-t pt-4 space-y-2">
                  {secondaryMenu.map((item) => (
                    <Link
                      key={item.href}
                      href={item.href}
                      className="block py-2 text-[#00479C] hover:text-[#003870]"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>

                {/* Auth Buttons Mobile */}
                <div className="border-t pt-4 space-y-2">
                  {isAuthenticated && user ? (
                    <div className="flex items-center gap-3">
                      {/* Avatar */}
                      <div className="w-10 h-10 rounded-full bg-[#b0c4d8] flex items-center justify-center flex-shrink-0">
                        {user.cover_image ? (
                          <Image
                            src={user.cover_image}
                            alt={user.display_name}
                            width={40}
                            height={40}
                            className="w-10 h-10 rounded-full object-cover"
                          />
                        ) : (
                          <User className="w-6 h-6 text-[#2c3e50]" />
                        )}
                      </div>
                      {/* Greeting */}
                      <span className="text-[14px] font-medium text-gray-800">
                        Hi, {user.display_name?.split(' ')[0]}!
                      </span>
                      {/* Thoát button */}
                      <a
                        href="https://caselaw.vn/auth/logout"
                        className="flex items-center gap-1.5 px-4 py-2 text-[13px] font-medium text-white bg-[#e05252] rounded-[5px] hover:bg-[#c94040] transition-colors ml-auto"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        <LogOut className="w-4 h-4" />
                        Thoát
                      </a>
                    </div>
                  ) : (
                    <>
                      <Link href="https://caselaw.vn/auth/register" className="block w-full text-center px-5 py-2 text-[14px] font-medium text-[#00479C] bg-white border-2 border-[#00479C] rounded-[5px] hover:bg-[#00479C] hover:text-white">
                        Đăng ký
                      </Link>
                      <Link href="https://caselaw.vn/auth/login" className="block w-full text-center px-5 py-2 text-[14px] font-medium text-white bg-[#00479C] border-2 border-[#00479C] rounded-[5px] hover:bg-[#003870]">
                        Đăng nhập
                      </Link>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </nav >
    </header >
  )
}
